import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/index.css'

// Initialize Office.js
Office.onReady((info) => {
  if (info.host === Office.HostType.PowerPoint) {
    const root = ReactDOM.createRoot(document.getElementById('root')!)
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    )
  }
})